export const POLICY_RTK_TAGS = {
  TAGS: 'POLICY',
  HASHID: 'POLICYHASHID',
};

export const usePolicies = () => ({});

export const useUpdatePolicy = () => ({});
export const useApprovePolicyVersion = () => ({});
export const convertLocationParamsToFetchParams = () => ({});

export const useDeletePolicy = () => ({});
export const usePolicyVersionById = () => ({});

export const extendedAPI = {
  endpoints: {
    getPolicies: {
      matchPending: () => false,
      matchRejected: () => false,
    },
  },
};
